import acknowledgements from './acknowledgements/sagas';
import assessments from './assessments/sagas';
import tenants from './tenants/sagas';

export default function* watchSagas() {
  yield* acknowledgements();
  yield* assessments();
  yield* tenants();
}
